import { render, staticRenderFns } from "./gtaBannerSwiper.vue?vue&type=template&id=04d22b16&scoped=true&"
import script from "./gtaBannerSwiper.vue?vue&type=script&lang=js&"
export * from "./gtaBannerSwiper.vue?vue&type=script&lang=js&"
import style0 from "./gtaBannerSwiper.vue?vue&type=style&index=0&id=04d22b16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d22b16",
  null
  
)

export default component.exports